import React from "react";
import { ITableModel } from "components/Table/interface";
import { colors } from "../../styles/colors";

export interface IReviewRateRow {
  id: string;
  businessUnit: string;
  representative: string;
  sellerCode: string;
  rate: number;
}

function CellNoWrap({ value }: { value: string }) {
  return (
    <span
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block",
        maxWidth: "100%",
      }}
      title={value}
    >
      {value}
    </span>
  );
}

export const reviewRateTableModel: ITableModel[] = [
  {
    label: "BU",
    key: "businessUnit",
    size: 80,
    noFilter: true,
    Component: (data: IReviewRateRow) => <CellNoWrap value={data.businessUnit} />,
  },
  {
    label: "Representante",
    key: "representative",
    size: 80,
    noFilter: true,
    Component: (data: IReviewRateRow) =>
      <CellNoWrap value={data.sellerCode ? (data.representative ? `${data.sellerCode} - ${data.representative}` : data.sellerCode) : "-"} />,
  },
  {
    label: "Taxa",
    key: "rate",
    size: 72,
    noFilter: true,
    Component: (data: IReviewRateRow) => {
      const display = `${Number(data.rate).toFixed(0)} %`;
      const isLow = Number(data.rate) < 50;
      return (
        <span style={{ color: isLow ? colors.alert : undefined }} title={display}>
          {display}
        </span>
      );
    },
  },
];
